/** Standard Canadian GST/HST rates offered as quick-fill shortcuts on the
 *  recoverable-amount editor: GST 5%, HST Ontario 13% (the current
 *  customer), HST Atlantic 15%. */
export const TAX_RATE_SHORTCUTS = [5, 13, 15] as const;

/** Back out the tax embedded in a TAX-INCLUDED total. The bill amount is
 *  assumed to already include the tax, so the recoverable tax is
 *  `bill × rate / (100 + rate)` — e.g. a $113.00 bill at 13% embeds $13.00
 *  of tax, a $105.00 bill at 5% embeds $5.00. Returns a 2-decimal string
 *  (ready to drop into the editor input), or null when `billAmount` isn't a
 *  positive finite number so the caller can hide the shortcut. */
export function taxIncludedRecovery(billAmount: string | null, ratePct: number): string | null {
  if (billAmount === null) return null;
  const bill = Number(billAmount);
  if (!Number.isFinite(bill) || bill <= 0) return null;
  return ((bill * ratePct) / (100 + ratePct)).toFixed(2);
}
